import HeadTittle from "../../../../components/HeadTittle";
import {Box} from "@mui/material";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import {AddIcon, CleanIcon} from "../../../../components/buttons/IconButtons";
import React from "react";
import {CreateVisitorInvitationApp} from "./Functionality/CreateVisitorInvitationApp";
import routes from "../../../../Routes/routes";
import ButtonIcon from "../../../../components/buttons/ButtonIcon";
import CreateVisitorInvitationForm from "./SubComponents/CreateVisitorInvitationForm";
import DivContainerBody from "../../../../components/DivContainerBody";
import CreateVisitorModal from "../Modal/CreateVisitorModal";
import {permissionObj} from "../../../../Helpers/permission";
import {MODELS} from "../../../../Apis/Models";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const CreateVisitorInvitation = () => {

    const {
        t,
        navigate,
        DEV,
        permission,
        requestAccessId,
        handleCreate,
        handleClear,
        handleChange,
        disabled,
        item,
        emptyFields,
        selectedList,
        setSelectedList,
        selectedHost,
        setSelectedHost,
        cleanChipSearchHost,
        setCleanChipSearchHost,
        addShow,
        setAddShow,
        modified,
        setModified,
        goBack,
        isValidStartDate,
        isValidEndDate
    } = CreateVisitorInvitationApp()

    if (!DEV &&
        !((permission?.includes(permissionObj.WEB_VISITOR_INVITATION_READ) && permission?.includes(permissionObj.WEB_VISITOR_INVITATION_CREATE)) ||
            (requestAccessId && permission?.includes(permissionObj.WEB_REQUEST_ACCESS_READ) && permission?.includes(permissionObj.WEB_REQUEST_ACCESS_MANAGE)))
    ) {
        navigate(routes.forbidden);
    }

    return (
        <>
            <HeadTittle name={'create'} onBack={goBack}
                        divStack={
                            <div className={"ml-1"}>
                                <ButtonIcon
                                    id='btn_cvi_clean'
                                    Icon={CleanIcon}
                                    onClick={handleClear}
                                    title={'clear_instances'}
                                    className={"btn-clean-secondary-600"}
                                    tooltipPlacement={"right"}
                                    iconProps='btn-icon-svg-12px icon-color-general-00'
                                />
                            </div>
                        }
            >
                <Box className='d-flex gap-2 justify-content-end align-items-center mb-2'>
                    <ButtonAction
                        id='btn_d_add'
                        name={ 'create'}
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={handleCreate}
                    />
                </Box>
            </HeadTittle>
            <DivContainerBody>
                <CreateVisitorInvitationForm
                    handleChange={handleChange}
                    disabled={disabled}
                    item={item}
                    emptyFields={emptyFields}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    selectedHost={selectedHost}
                    setSelectedHost={setSelectedHost}
                    cleanChipSearchHost={cleanChipSearchHost}
                    setCleanChipSearchHost={setCleanChipSearchHost}
                    setAddShow={setAddShow}
                    setModified={setModified}
                    requestAccessId={requestAccessId}
                    isValidStartDate={isValidStartDate}
                    isValidEndDate={isValidEndDate}
                />
            </DivContainerBody>
            <CreateVisitorModal
                title={t('create_visitor')}
                check='true'
                show={addShow}
                onHide={() => setAddShow(false)}
                modified={modified}
                setModified={setModified}
                setSelectedList={setSelectedList}
                selectedList={selectedList}
                moduleId={MODELS.VISITOR_INVITATION}
            />
        </>
    )

}

export default CreateVisitorInvitation
